/**
 * Pulls the message the API returned out of a failed request
 *
 * @param error - The thrown error, typically an axios error
 * @param fallback - Message to use when the API did not return one
 * @returns The API's error message, or the fallback
 */
export const getApiErrorMessage = (
	error: unknown,
	fallback: string,
): string => {
	const message = (error as { response?: { data?: { message?: unknown } } })
		?.response?.data?.message;

	return typeof message === "string" && message.length > 0 ? message : fallback;
};
